import React from 'react';
import './Skeleton.css';

export default function PodcastContentSkeleton() {
    return (
        <div className="w-full space-y-6 py-4 skeleton-fade-in" aria-busy="true" aria-label="Loading podcast details">
            {/* Show Notes Header */}
            <div className="space-y-2">
                <div className="h-6 w-48 rounded-lg shimmer-pulse" />
                <div className="h-4 w-3/4 rounded shimmer-pulse opacity-70" />
            </div>

            {/* Description Paragraphs */}
            <div className="space-y-3">
                <div className="h-4 w-full rounded shimmer-pulse" />
                <div className="h-4 w-[98%] rounded shimmer-pulse" />
                <div className="h-4 w-[95%] rounded shimmer-pulse" />
                <div className="h-4 w-[80%] rounded shimmer-pulse" />
            </div>

            {/* Chapter Timestamps Preview Shimmer */}
            <div className="p-4 rounded-xl border border-slider bg-hover space-y-3">
                <div className="h-5 w-36 rounded shimmer-pulse" />
                <div className="space-y-2">
                    <div className="flex items-center gap-3">
                        <div className="h-4 w-14 rounded-full shimmer-pulse" />
                        <div className="h-4 w-48 rounded shimmer-pulse" />
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="h-4 w-14 rounded-full shimmer-pulse" />
                        <div className="h-4 w-60 rounded shimmer-pulse" />
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="h-4 w-14 rounded-full shimmer-pulse" />
                        <div className="h-4 w-40 rounded shimmer-pulse" />
                    </div>
                </div>
            </div>

            {/* Paragraph 2 */}
            <div className="space-y-3">
                <div className="h-4 w-full rounded shimmer-pulse" />
                <div className="h-4 w-[96%] rounded shimmer-pulse" />
                <div className="h-4 w-[65%] rounded shimmer-pulse" />
            </div>
        </div>
    );
}
